import {useCallback, useState} from "react";
import {
    apiGetUserVerificationFlows,
    apiGetUserVerificationTiers,
    apiGetVerificationTierSettingsAccessRights
} from "../../../api/restful/verification";

export const useGetUserVerificationFlows = () => {
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [previousParam, setPreviousParam] = useState({
        filter: {},
        sort: {},
        offset: 0,
        limit: 0,
    });

    const getUserVerificationFlows = useCallback(
        async (param = {}) => {
            setLoading(true);
            setPreviousParam(param);

            try {
                const result = await apiGetUserVerificationFlows(param);

                if (result?.status === "failed") {
                    setData([]);
                    setTotal(0);
                    return;
                }

                setData(result?.data);
                setTotal(result?.total);
                return result;
            } catch (e) {
                console.error("getUserVerificationFlows error:", e);
                throw e;
            } finally {
                setLoading(false);
            }
        },
        []
    );

    const refetchUserVerificationFlows = useCallback(() => {
        if (previousParam) {
            getUserVerificationFlows(previousParam);
        }
    }, [previousParam, getUserVerificationFlows]);

    return {
        data,
        total,
        loading,
        getUserVerificationFlows,
        refetchUserVerificationFlows,
    };
};

export const useGetUserVerificationTiers = () => {
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [previousParam, setPreviousParam] = useState({
        filter: {},
        sort: {},
        offset: 0,
        limit: 0,
    });

    const getUserVerificationTiers = useCallback(
        async (param = {filter: {}, sort: {}, limit: 0, offset: 0}) => {
            setLoading(true);
            setPreviousParam(param);

            try {
                const result = await apiGetUserVerificationTiers(param);

                if (result?.status === "failed") {
                    setData([]);
                    setTotal(0);
                    return;
                }

                setData(result?.data);
                setTotal(result?.total);
                return result;
            } catch (e) {
                console.error("getUserVerificationTiers error:", e);
                throw e;
            } finally {
                setLoading(false);
            }
        },
        []
    );

    const refetchUserVerificationTiers = useCallback(() => {
        if (previousParam) {
            getUserVerificationTiers(previousParam);
        }
    }, [previousParam, getUserVerificationTiers]);

    return {
        data,
        total,
        loading,
        getUserVerificationTiers,
        refetchUserVerificationTiers,
    };
};

export const useGetUserVerificationAccessRightsList = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const getUserVerificationAccessRightsList = useCallback(
        async () => {
            setLoading(true);

            try {
                const result = await apiGetVerificationTierSettingsAccessRights();

                if (result?.status === "failed") {
                    setData([]);
                    return;
                }

                setData(result?.data);
                return result;
            } catch (e) {
                console.error("getUserVerificationAccessRightsList error:", e);
                throw e;
            } finally {
                setLoading(false);
            }
        },
        []
    );

    return {
        data,
        loading,
        getUserVerificationAccessRightsList,
    };
};